<div appBadgeScanner [isScanListenerActive]="isScanListenerActive" (scan)="onScan($event)"></div>
<div class="field" [class.invalid]="hasError">
    <app-input [(ngModel)]="value"
               [label]="label"
               [placeholder]="placeholder"
               (ngModelChange)="onScan($event)"
               type="text">
    </app-input>
    <i [class.hidden]="!value"
       class="material-icons clear-button"
       (click)="onClear()">clear</i>
    <app-form-error-list *ngIf="showErrors"
                         [errorMap]="formControl.errors"></app-form-error-list>
</div>
